import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-panther-lake-va-page',
  templateUrl: './panther-lake-va-page.component.html',
  styleUrls: ['./panther-lake-va-page.component.scss']
})
export class PantherLakeVAPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.dispatchEvent(new CustomEvent('OPEN_AI_BOT',{ detail: "OPEN_CHATBOT"})); 
  }
 ngOnDestroy(): void {
    window.dispatchEvent(new CustomEvent('VA_TAB_EXIT_EVENT', { detail: true }));
  }
}
